import React, { FC, useState, useEffect } from "react";
import { RouterParamType } from "@/model/navModel";
import { YhBox } from "@/components/YhBox";
import { Button } from "antd";
import "./PowerOfAttroney.less"
import { exportPDF } from "@/utils/exportPDF";
import { useDtpDetailModel } from "../dtpDetailModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { salesService } from "@/views/sales/salesService";

export const PowerOfAttroney: FC<RouterParamType> = (detailsInfo) => {
    const { getTreeNodeName } = useDictModel(() => []);
    const [bookingTime, setBookingTime] = useState("");
    const {
        editFormVal,
        updateFormVal,
    } = useDtpDetailModel(({ editFormVal }) => [editFormVal]);

    useEffect(() => {
        //查物流进程
        salesService.oneLog(editFormVal.saleCode as string).then(res => {
            if (res.retData && typeof res.retData?.bookingTime === "string") {
                setBookingTime(res.retData?.bookingTime)
            }
        });
    }, [])
    return (
        <YhBox title="" style={{ marginBottom: "75px" }} >
            <div style={{ width: "80%", margin: "10px auto" }}>
                <Button type="link" onClick={() => exportPDF('订舱委托书', "PowerOfAttroneyPDF")}>导出PDF</Button>
                <br />
                <div id="PowerOfAttroneyPDF">
                    <table>
                        <tbody>
                            <tr>
                                <td colSpan={3}>
                                    <p style={{ fontWeight: "bold" }}>Shipper发货人</p>
                                    <p>{editFormVal.bentityName}</p>
                                    <p>ADD:{editFormVal.shipAddress}</p>
                                    <p>Tel：{editFormVal.consignerPhone}</p>
                                </td>
                                <td width={'50%'} colSpan={3} rowSpan={3} >
                                    <p className="line"></p>
                                    <h2 className="align-center">货物订舱委托书</h2>
                                    <h2 className="align-center"> Booking Notice</h2>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={3}>
                                    <p style={{ fontWeight: "bold" }}>Consignee收货人</p>
                                    <p>{editFormVal.customerName}</p>
                                    <p>Address：{editFormVal.shippingAddress}</p>
                                    <p>Tel：{editFormVal.consigneePhone}</p>
                                    <p>Fax：{editFormVal.consigneeFax}</p>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={3}>
                                    <p style={{ fontWeight: "bold" }}>Notify party通知人</p>
                                    <p>&nbsp;{editFormVal.notifier}</p>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={1}>
                                    <p style={{ fontWeight: "bold" }}> Shipment Port装货地</p>
                                    <p>&nbsp;{getTreeNodeName(editFormVal.shipment)}</p>
                                </td>
                                <td colSpan={2}>
                                    <p style={{ fontWeight: "bold" }}> Discharge Port卸货地 </p>
                                    <p>&nbsp;{getTreeNodeName(editFormVal.discharge)}</p>
                                </td>
                                <td colSpan={1} rowSpan={2}>
                                    <p style={{ fontWeight: "bold" }}>Trade terms : </p>
                                    <p>&nbsp;{getTreeNodeName(editFormVal.bargainType)}{editFormVal.bargainType=='trade-fob'?getTreeNodeName(editFormVal.shipment):getTreeNodeName(editFormVal.discharge)}</p>
                                </td>
                                <td colSpan={2} rowSpan={2}>
                                    <p style={{ fontWeight: "bold" }}>B. Other freight其它费用:</p>
                                    {/* <p>&nbsp;{editFormVal.otherExpenses}</p> */}
                                    <p>&nbsp;</p>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={1}>
                                    <p style={{ fontWeight: "bold" }}> Destination目的地</p>
                                    <p>&nbsp;{getTreeNodeName(editFormVal.discharge)}</p>
                                    {/* <p>&nbsp;{editFormVal.shippingAddress}</p>  */}
                                </td>
                                <td colSpan={2}>
                                    <p style={{ fontWeight: "bold" }}> PRICE TERMS 成交方式</p>
                                    <p>&nbsp;{getTreeNodeName(editFormVal.bargainType)}{editFormVal.bargainType=='trade-fob'?getTreeNodeName(editFormVal.shipment):getTreeNodeName(editFormVal.discharge)}</p>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={1} rowSpan={2}>
                                    <p style={{ fontWeight: "bold" }}>Marks No唛头</p>
                                    <p>&nbsp;{editFormVal.labelNote}</p> 
                                </td>
                                <td colSpan={2} rowSpan={2}>
                                    <p style={{ fontWeight: "bold" }}>Packing and No. of packages 包装及件数</p>
                                    <p>&nbsp;{editFormVal.packingNum}</p>
                                </td>
                                <td colSpan={1} rowSpan={2}>
                                    <p style={{ fontWeight: "bold" }}>Description of goods货物名称及海关编码</p>
                                    <p>{editFormVal.goodsName}/&nbsp;{editFormVal.customsCode}</p>
                                </td>
                                <td colSpan={1} rowSpan={2} >
                                    <p style={{ fontWeight: "bold" }}>Weight(kgs)</p>
                                    <p>&nbsp;{editFormVal.roughWeight}</p>
                                </td>
                                <td colSpan={1} rowSpan={2}>
                                    <p style={{ fontWeight: "bold" }}>Meas(cbm)</p>
                                    <p>&nbsp;{editFormVal.volume}</p>
                                </td>
                            </tr>
                            <tr>
                            </tr>
                            <tr>
                                <td colSpan={6} className="dashed-bottom">
                                    <p style={{ fontWeight: "bold" }}>Engage special arrangement特约事项:</p>
                                    <p>&nbsp;{editFormVal.specialRemark}</p>
                                </td>
                            </tr>
                            <tr className="seal">
                                <td className="dashed-right dashed-top" colSpan={3}></td>
                                <td colSpan={3} className="dashed-left dashed-top">
                                    <p style={{ fontWeight: "bold" }}>发货公司：{editFormVal.bentityName}</p>
                                    {/* <p>日期：{moment().format("YYYY-MM-DD")}</p> */}
                                    <p>日期：{bookingTime}</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </YhBox>
    )
}